import React from "react";
import Container from "../../hoc/Container";
import { tgIcon } from "../../../images";

function PlayStationInfo() {
  return (
    <Container>
      <article className="content-block-no-top-bottom-padding">
        <section className="my-5">
          <h3 className="my-2 text-center text-2xl overline decoration-sky-500">
            Боты для покупки карт оплаты
          </h3>
          <div
            onClick={() => window.ym(93997310, "reachGoal", "tgClickPlayStation")}
            className="flex flex-col items-center justify-center gap-2 sm:flex-row sm:gap-4 md:flex-col md:gap-2"
          >
            <a
              href={"https://t.me/trendy_psn_bot?start=ref-001"}
              className="flex w-40 justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              target="_blank"
              rel="noreferrer"
            >
              Купить в <img src={tgIcon} alt="TG" className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
            </a>
          </div>
        </section>
        <section className="my-5">
          <h3 className="my-2 text-center text-2xl overline decoration-sky-500">
            Описание
          </h3>
          <p className="dark-text my-3 w-full text-justify indent-4 text-gray-700">
            В нашем магазине вы можете легко, просто и удобно
            купить карты оплаты для PlayStation, пополнить кошелек PSN и купить
            любую интересующую вас игру. Или можете сделать отличный подарок
            геймеру с помощью подарочных карт PlayStation.
          </p>
        </section>
        <section className="my-5">
          <h3 className="my-2 text-center text-2xl">
            Подарочная карта PlayStation Gift Card
          </h3>
          <p className="dark-text my-3 w-full text-justify indent-4 text-gray-700">
            Наши карты можно купить сейчас, а активировать когда вам будет удобно.
            Это еще одна причина почему PlayStation Gift Card – это прекрасный подарок
            для любого фаната эксклюзивов PS и не только.
          </p>
          <p className="dark-text my-3 w-full text-justify indent-4 text-gray-700">
            Подарочная карта представляет собой специальный 12-значный код,
            который необходимо ввести в приложении PlayStation. Или на
            <a
              href="https://store.playstation.com"
              className="text-blue-700 dark:text-indigo-400"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              сайте PlayStation{" "}
            </a>
            зайдя под своей учетной записью. С ее помощью удается получить
            средства на балансе, сумма которых кратна номиналу карты.
          </p>
          <p className="dark-text my-3 w-full text-justify indent-4 text-gray-700">
            Использовать такой способ пополнения можно как для уже существующих
            аккаунтов, так и для новых.
          </p>
        </section>
        <section className="my-5">
          <h3 className="my-2 text-center text-2xl">Особенности регионов</h3>
          <p className="dark-text my-3 w-full text-justify indent-4 text-gray-700">
            Активировать карту можно находясь в любой стране, без использования
            VPN.
          </p>
          <section>
            <h4 className="my-2 indent-4 text-base">
              Особенности Польского региона:
            </h4>
            <ul className="dark-text ms-10 list-inside list-decimal text-gray-700">
              <li>Все игры, которые должны иметь русскую озвучку – ее имеют</li>
              <li>Цены чуть выше чем были раньше в России</li>
              <li>Есть полная Premium подписка, а не Deluxe</li>
            </ul>
          </section>
        </section>
      </article>
    </Container>
  );
}

export default PlayStationInfo;
